.modal {
  min-width: 400px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: space-between;
}

.radios {
  display: flex;
  gap: 12px
}

.text {
  font-size: 14px;
}

.desc {
  font-size: 12px;
}
